import {
  TenantLogoArgs,
  TenantLogoResponse,
} from "shared-ui/src/shared-features/my-acccounts/types/TenantLogo";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { CustomerTenantLogoClient } from "@lib/ShiOneClient";
import { useApi } from "@utils/useApi";
import ms from "ms";

const CustomerTenantLogoQKey = "customer-tenant-logo";

export default function useGetTenantLogo({
  id,
}: TenantLogoArgs): UseQueryResult<TenantLogoResponse | null, Error> {
  const api = useApi(CustomerTenantLogoClient);
  const fetch = async (): Promise<TenantLogoResponse | null> => {
    if (!id) return null;
    try {
      const res = await api.downloadByTenantId(id);
      return {
        body: await res.data.arrayBuffer(),
        contentType: res.headers?.["content-type"] ?? null,
      };
    } catch (error: unknown) {
      return null;
    }
  };

  return useQuery({
    queryKey: [CustomerTenantLogoQKey, id],
    enabled: !!id,
    queryFn: fetch,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: ms("60m"),
  });
}
